import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller<HTMLElement> {
  static values = {
    turboFrameUrl: String,
    turboFrameId: String
  }

  declare readonly turboFrameUrlValue: string
  declare readonly hasTurboFrameUrlValue: boolean
  declare readonly turboFrameIdValue: string
  declare readonly hasTurboFrameIdValue: boolean

  connect(): void {
    const modal = this.element.querySelector('ui-modal')
    if (!this.hasTurboFrameUrlValue || !this.hasTurboFrameIdValue || modal === null) return

    modal.addEventListener('toggle', (event: Event) => {
      const isOpen = (event as ToggleEvent).newState === 'open'
      if (!isOpen) return
      const connectorChar = this.turboFrameUrlValue.includes('?') ? '&' : '?'
      const urlToVisit = `${this.turboFrameUrlValue}${connectorChar}turbo_frame_id=${this.turboFrameIdValue}`
      Turbo.visit(urlToVisit, {
        frame: this.turboFrameIdValue
      })
    })
  }

  toggle(e: MouseEvent): void {
    const modal = this.element.querySelector('ui-modal') as HTMLElement

    modal.togglePopover()

    e.preventDefault() // Prevent Chrome from immediately closing the modal again.
  }
}
